export { default as BookOpenSolidIcon } from './BookOpenSolidIcon';
